<template>
    <div class="videoCoverItem" @click="enterDetails">
        <div class="videoCoverItemImg">
            <img src="~assets/images/temporary/videoCoverImg.jpg" alt="">
            <div>
                <i class="el-icon-video-play"></i>
            </div>
        </div>
        <div class="videoCoverItemContent">
            <p class="ellipsis">西方诗歌鉴赏</p>
            <span>时长：166分51秒</span>
            <div>
                <div>
                    <img src="~assets/images/index/sUserImg.jpg" alt="">
                    <span>557人学习</span>
                </div>
                <div>
                    <img src="~assets/images/index/hotImg.jpg" alt="">
                    <span>热度：5793</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        //要跳转的路由
        path:{
            type:String,
            default:''
        }
    },
    data(){
        return{

        }
    },
    methods:{
        enterDetails(){
            let path = this.path;
            this.$router.push({
                path
            })
        }
    }
}
</script>

<style lang="less" scoped>
.videoCoverItemContent{
    padding: 0 6px;
    height: calc(100% - 180px);
    display: flex;
    flex-direction: column;
    >p{
        height: 28px;
        line-height: 28px;
        font-size: 14px;
        font-weight: bold;
        color: #000;
    }
    >span{
        font-size: 12px;
        color: #7e7e7e;
    }
    >div{
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        div{
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 12px;
            color: #7e7e7e;
            img{
                margin: -2px 4px 0 0;
            }
        }
    }
}
.videoCoverItemImg{
    height: 180px;
    position: relative;
    >img{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
    >div{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 9;
        background: rgba(0,0,0,.6);
        display: flex;
        align-items: center;
        justify-content: center;
        >i{
            font-size: 28px;
            color: #fff;
        }
    }
}
.videoCoverItem{
    margin: 10px;
    width: 260px;
    height: 256px;
    background: #fff;
    box-shadow: 0 0 10px 1px rgba(70,70,70,.25);
    cursor: pointer;
}
</style>
